import axios from "~/plugins/axios";

export default {
  getCurrent() {
    return axios.get("/web_api/v1/tenant/current").then((response) => response.data);
  },
  getSetting(settingKey) {
    return axios.get(`/web_api/v1/tenant/setting/${settingKey}`).then((response) => response.data);
  },
};
